import * as React from 'react';
import Login from '@ui/scenes/Login';

const LoginPage: React.FunctionComponent<{}> = () => <Login />;

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/Login/Login.tsx